import { translate } from 'components/translate-hoc';
import StepsDescriptionReward from './steps-description-reward.component';

export default translate()(StepsDescriptionReward);
